<template>
  <div>
    <div v-if="devices != null && devices.length === 0">
      <b-row class="align-center">
        <b-col><i>Aucune tablette</i></b-col>
      </b-row>
      <!--b-row class="align-center">
        <b-col><b-button v-b-modal.modal-import-staff-list variant="primary">Importer</b-button></b-col>
        <b-modal id="modal-import-staff-list" title="Importer une liste de staff" scrollable hide-footer>
          <form-import-list v-on:sendForm="receiveForm" :id="this.id"></form-import-list>
        </b-modal>
      </b-row-->
    </div>
    <div v-else>
      <b-button
        v-b-toggle="'list-invisible-device'"
        v-if="full"
        class="m-1"
        variant="info"
      >
        <span class="when-open"
          ><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span
        >
        <span class="when-closed"
          ><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span
        >
        {{ $t("label.list_tablets") }}
      </b-button>
      <b-collapse id="list-invisible-device" :visible="!full">
        <b-row class="justify-content-md-center" align-v="center">
          <b-col align-self="center">
            <b-row>
              <b-col>
                <b-form-group
                  label="Filtrer"
                  label-cols-sm="3"
                  label-align-sm="left"
                  label-size="sm"
                  label-for="filterInput"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filterInput"
                      v-model="filter"
                      type="search"
                      placeholder="Taper pour rechercher une tablette"
                    />
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''"
                        >Effacer</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              :fields="fields"
              :items="devices"
              :filter="filter"
              :filter-included-fields="filterOn"
              small
              responsive="sm"
            >
              <template #cell(dev_serial)="row">
                <b-col>{{ row.item.dev_serial }}</b-col>
              </template>
              <template #cell(dev_appversion)="row">
                <b-col>{{ row.item.dev_meta?.app_version || row.item.dev_appversion }}</b-col>
              </template>
              <template #cell(dev_last_synchro)="row">
                <b-col>{{ row.item.dev_last_synchro }}</b-col>
              </template>
              <template #cell(dev_access)="row">
                <b-col>{{ row.item.dev_access }}</b-col>
              </template>
              <template #cell(dev_state)="row">
                <b-col>
                  <b-badge v-if="row.item.dev_state" variant="success"
                    >Connecté</b-badge
                  >
                  <b-badge v-else variant="danger">Déconnecté</b-badge>
                </b-col>
              </template>
              <template #cell(update)="row">
                <b-row>
                  <b-col>
                    <b-button
                      v-if="!full"
                      size="sm"
                      variant="outline-warning"
                      @click="$emit('fix', row.item)"
                      >Dépanner</b-button
                    >
                    <b-button
                      v-if="full && row.item.dev_state"
                      size="sm"
                      variant="danger"
                      @click="disconnect(row.item)"
                      >Déconnecter</b-button
                    >
                  </b-col>
                </b-row>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { operationBus } from "../../main";

export default {
  name: "ListDevices",
  props: {
    devices: {
      type: Array,
      default: null,
    },
    full: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      title: "Modale Troubleshoot",
      fields: [
        {
          dev_serial: {
            label: "Numéro de série",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          dev_appversion: {
            label: "Version du STORE",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          dev_last_synchro: {
            label: "Dernière synchro",
            sortable: true,
            tdClass: this.full ? "align-middle" : "d-none",
            thClass: this.full ? "align-middle" : "d-none",
          },
        },
        {
          dev_access: {
            label: "Accès",
            sortable: true,
            tdClass: this.full ? "align-middle" : "d-none",
            thClass: this.full ? "align-middle" : "d-none",
          },
        },
        {
          dev_state: {
            label: "Statut",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          update: {
            label: "Actions",
            sortable: false,
            tdClass: "align-middle",
          },
        },
      ],
      filter: null,
      filterOn: [],
    };
  },
  computed: {},
  beforeMount() {
    // console.log("ListDevice mounted", this.full)
    // this.fields.find(e => e.dev_access).tdClass = this.full ? 'align-middle' : 'd-none'
    // console.log("ListDevice mounted", this.fields.find(e => e.dev_access))
    // this.fields.find(e => e.dev_last_synchro).tdClass = this.full ? 'align-middle' : 'd-none'
  },
  mounted() {},
  methods: {
    disconnect(device) {
      const operation = {
        id: this.id, // TODO : Generate id
        cancel: false,
        action: `la déconnexion de la tablette : ${device.dev_serial}`,
        request: "establishments/closeConnectionDevice",
        params: { dev_id: device.dev_id },
      };
      operationBus.$emit("operationAdded", operation);
    },
  },
};
</script>
<style>
</style>
